module.exports = __webpack_public_path__ + "static/media/item_4_4_comp.6333302d.png";